import { Component } from "@angular/core";
import { UtilsService } from "src/app/core/services/utils.service";

@Component({
	selector: "app-toasts",
	template: `
		@for (toast of utilsService.toasts; track toast) {
			<ngb-toast class="bg-{{ toast.status }} text-light text-center" [autohide]="true" [delay]="toast.delay || 1500" (hidden)="utilsService.removeToast(toast)">
				<i class="las la-info-circle align-middle fw-bold" style="font-size: 20px;"></i>
				&nbsp;
				{{ toast.message }}
			</ngb-toast>
		}
	`,
	host: { class: "toast-container position-fixed start-50 translate-middle-x pb-2", style: "z-index: 1200; bottom: 2px;" },
})
export class ToastsContainer {
	constructor(public utilsService: UtilsService) {}
}
